// extracted by mini-css-extract-plugin
export default {"page":"KZ0yl","pluginPage":"gn7gS","loading":"C5uRD","header":"hYPrX"};